module.exports = __webpack_public_path__ + "static/img/hy01.fed080d3.png";